import { atom, selector } from 'recoil'
import { saveUserToLocalStorage } from '../functions/localStorageManager'
import { productItems } from '../commons/productItems'
import { factories } from '../commons/factories'
export const appVersion = '2.2.0'
const loginUser = {
  appVersion: appVersion,
  mail: '', // 空文字で初期化
  photoURL: '', // 空文字で初期化
  workerName: '', // 社員名を空文字で初期化
  isAuth: false, // 認証状態をfalseで初期化
  mode: 'dark',
  filters: {
    productNo: '',
    drawingNames: [], //図面名・タブ名（複数選択）
    excludeDrawingNames: [], //除外図面名（複数選択）
    documentNames: [], //文書名（複数選択）
    excludeDocumentNames: [], //除外文書名（複数選択）
    factories: factories.map((factory) => factory.id), //工場（複数選択）
    productItems: productItems.map((product) => product.id), //製品項目（複数選択）
    isUpdateEnable: false,
    drawingUpdFrm: '',
    drawingUpdTo: '',
    keywords: '',
    latestOnly: true,
  },
}
const initializeUserFromLocalStrate = () => {
  const storedUser = localStorage.getItem('LoginUserOnAquaDRAFTS')
  if (storedUser) {
    try {
      const userObject = JSON.parse(storedUser)
      if (!userObject.appVersion || userObject.appVersion !== appVersion) {
        localStorage.clear()
        return loginUser
      }
      return userObject
    } catch (error) {
      console.error('Parsing error', error)
      return loginUser // パースに失敗した場合のデフォルト値
    }
  } else {
    return loginUser // LocalStorageにデータがない場合のデフォルト値
  }
}
export const userState = atom({
  key: 'userState',
  default: initializeUserFromLocalStrate(),
})

//アクセッサの定義
// 🔹 `userState.filters` の各プロパティに対する selector
const createSelectorWithLocalStorage = (key, property) => {
  return selector({
    key,
    get: ({ get }) => get(userState).filters[property],
    set: ({ set, get }, newValue) => {
      const updatedUser = {
        ...get(userState),
        filters: { ...get(userState).filters, [property]: newValue },
      }
      set(userState, updatedUser)
      saveUserToLocalStorage(updatedUser) // localStorage にも保存
    },
  })
}

export const drawingNamesState = createSelectorWithLocalStorage(
  'drawingNamesState',
  'drawingNames'
)
export const excludeDrawingNamesState = createSelectorWithLocalStorage(
  'excludeDrawingNamesState',
  'excludeDrawingNames'
)

export const documentNamesState = createSelectorWithLocalStorage(
  'documentNamesState',
  'documentNames'
)
export const excludeDocumentNamesState = createSelectorWithLocalStorage(
  'excludeDocumentNamesState',
  'excludeDocumentNames'
)

export const factoriesState = createSelectorWithLocalStorage(
  'factoriesState',
  'factories'
)

export const productItemsState = createSelectorWithLocalStorage(
  'productItemsState',
  'productItems'
)
